import styled from 'styled-components'

export const Container = styled.div`
  padding: var(--space-600);
  border-radius: var(--radius-brand);
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
`

export const Title = styled.h2`
  font-size: var(--font-size-500);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
`

export const Description = styled.p`
  font-size: var(--font-size-400);
  line-height: 1.6;
  color: var(--text-secondary);
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: var(--space-200);
`
